import { render, staticRenderFns } from "./quickPrintGoodsLabel.vue?vue&type=template&id=888f57fa&"
import script from "./quickPrintGoodsLabel.vue?vue&type=script&lang=js&"
export * from "./quickPrintGoodsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "quickPrintGoodsLabel.vue"
export default component.exports